import clsx from 'clsx';
import React, { ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import CustomSelect from "../UI/customSelect/customSelect";
import { useMutation, useQuery } from 'react-query';
import { Get, Post } from 'src/apis/api';
import Loading from 'src/components/Loading';
import { ListResponseType, Visa } from 'src/types';
import { Close } from 'src/icons/icons';
import { toast } from 'react-toastify';

export const ExtendVisa = ({ crewsData, duplicate_visa_id, onSuccessMutate, children }: { crewsData: Array<{ id: string, job_id: string }>, duplicate_visa_id: string, onSuccessMutate: Function, children?: ReactNode }) => {

    const { t } = useTranslation();

    const [selectedVisa, setSelectedVisa] = useState<{ name: string, value: string } | undefined>()

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    const { data, isLoading } = useQuery<{}, {}, ListResponseType<Visa>>({
        queryFn: () => Get('/agent/profile/visas'),
        queryKey: ['getVisaTypes'],
        enabled: isModalOpen
    })


    const { isLoading: loadingOfExtend, mutate } = useMutation<{}, { data: { message: string, msg: string } }>({
        mutationFn: () => Post('agent/visas/store', {
            form: "store_form",
            visa_id: selectedVisa?.value,
            duplicate_visa_id,
            crews: crewsData
        }),
        mutationKey: ['ExtendVisa', duplicate_visa_id],
        onSuccess: (res: any) => {
            toast.success(res.msg);
            onSuccessMutate()
            setIsModalOpen(false)
        },
        onError: (error) => {
            toast.error(error?.data?.message || error?.data?.msg);
        },
    })


    return (
        <>

            {!!children
                ? <div className='flex' title={t('extend')} onClick={() => setIsModalOpen(true)}>{children}</div>
                : <button className='bg-primary-200  text-primary-400  p-2 rounded-lg text-sm font-bold lg:min-w-32' title={t('extend')} onClick={() => setIsModalOpen(true)}>{t('extend')}</button>}



            {isModalOpen && createPortal(<div className={clsx('fixed top-0 left-0 h-full w-full backdrop-brightness-50 z-40 flex flex-row justify-center items-center', !isModalOpen ? 'opacity-0' : ' opacity-100')}>
                <div className={clsx('flex flex-col gap-6 transition-all duration-300 bg-white max-w-[80vw] lg:max-w-[450px] min-w-64 rounded-2xl border p-4 relative', !isModalOpen ? 'translate-y-full' : 'translate-y-0')}>

                    <div className='absolute left-4 top-4 cursor-pointer' onClick={() => setIsModalOpen(false)}> <Close color='gray' /></div>

                    <span className='text-primary-400 text-lg text-center p-4 pb-0'>{t('SelectExtendVisaType')}</span>

                    {isLoading && <div className='mx-auto text-gray-800'><Loading /></div>}

                    {data?.details && <div className='text-sm'><CustomSelect
                        name={'visa_id'}
                        label={t('ExtendVisaType')}
                        options={data?.details?.data?.data.filter(i => !!i.duplicate)}
                        onchange={(record: any) => setSelectedVisa(record)}
                        disable={undefined}
                        enName={'name'}
                    /></div>}


                    <button className='bg-primary-300 p-3 cursor-pointer rounded-lg text-white flex flex-row justify-center' disabled={loadingOfExtend} onClick={() => mutate()}>
                        {loadingOfExtend
                            ? <Loading /> :
                            t('confirm')}</button>
                </div>

            </div>
                , document.body)}
        </>
    )
}
